import { render, staticRenderFns } from "./invitationDelete.vue?vue&type=template&id=6aa3f340&"
import script from "./invitationDelete.vue?vue&type=script&lang=js&"
export * from "./invitationDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports